import { render, staticRenderFns } from "./internalunit.vue?vue&type=template&id=68058b5e&scoped=true"
import script from "./internalunit.vue?vue&type=script&lang=js"
export * from "./internalunit.vue?vue&type=script&lang=js"
import style0 from "./internalunit.vue?vue&type=style&index=0&id=68058b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68058b5e",
  null
  
)

export default component.exports